// extracted by mini-css-extract-plugin
module.exports = {"root":"_TCWwH1aj","content":"_BN7r8MQF"};